/**
 * Cryptographic Codecs
 *
 * Centralized, strict implementations for Base64 and Base64URL encoding/decoding.
 * Uses native environment capabilities (atob/btoa) with robust character handling.
 */
/**
 * Generate a random challenge for WebAuthn ceremonies
 */
export function generateChallenge(length = 32) {
    const buffer = new Uint8Array(length);
    crypto.getRandomValues(buffer);
    return encodeBase64Url(buffer);
}
/**
 * Encode bytes to Standard Base64
 */
export function encodeBase64(bytes) {
    const arr = bytes instanceof ArrayBuffer ? new Uint8Array(bytes) : bytes;
    let binary = '';
    const len = arr.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(arr[i]);
    }
    return btoa(binary);
}
/**
 * Decode Standard Base64 to bytes
 */
export function decodeBase64(str) {
    try {
        const binary = atob(str);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }
    catch (e) {
        throw new Error(`Invalid Base64 string: ${e instanceof Error ? e.message : String(e)}`);
    }
}
/**
 * Encode bytes to Base64URL (RFC 4648)
 * - Replaces '+' with '-'
 * - Replaces '/' with '_'
 * - Removes trailing '=' padding
 */
export function encodeBase64Url(bytes) {
    const base64 = encodeBase64(bytes);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
/**
 * Decode Base64URL to bytes
 * - Replaces '-' with '+'
 * - Replaces '_' with '/'
 * - Adds necessary '=' padding
 */
export function decodeBase64Url(str) {
    let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
        base64 += '=';
    }
    return decodeBase64(base64);
}
//# sourceMappingURL=codec.js.map